__turbopack_context__.v({
  "draft": "fqlSLG_draft",
  "draft__tag": "fqlSLG_draft__tag",
});
